import React from 'react';
import fetch from '@/hooks/fetch';
import { sortMembersByNameThenEmail } from '../helper';
import MemberPermissionRow from './MemberPermissionRow';

const MemberPermissionsTableRows = ({
  allowAdd,
  allowRemove,
  allowSecure,
  entity,
  fetchData,
  items,
  onChange,
  permissionGroups,
  readStatus,
  removeMember,
}) => {
  fetch.useFetch(fetchData, readStatus);
  return (
    [...items].sort(sortMembersByNameThenEmail).map((item) => (
      <MemberPermissionRow
        key={`member_permissions_table_row_${item.uuid || item.code}`}
        member={item}
        entity={entity}
        permissionGroups={permissionGroups}
        onChange={onChange}
        removeMember={removeMember}
        allowAdd={allowAdd}
        allowRemove={allowRemove}
        allowSecure={allowSecure}
      />
    ))
  );
};

export default MemberPermissionsTableRows;
